import React from 'react'

import { useIntl } from 'react-intl'
import EmptyState from '@/components/empty-state'

const ModalUserGroupsAccessListEmptyState = () => {
	const { formatMessage } = useIntl()

	return (
		<EmptyState
			iconName="GroupAdd"
			title={formatMessage({
				id: 'user_groups.empty_state.no_access_items',
			})}
			description={formatMessage({
				id: 'user_groups.empty_state.add_users_branches',
			})}
			hint={formatMessage({
				id: 'user_groups.empty_state.use_form_above',
			})}
		/>
	)
}

export default ModalUserGroupsAccessListEmptyState
